export enum UserValidationSubcodes {
  NoValidSubscription = 0,
  TermsAndConditionsNotAccepted = 3,
}
